/**
 * Sernelle — shipping promise.
 * Recalcule chaque minute, dans le fuseau America/New_York :
 *  - [data-sa-cutoff]  : « Order within 2h 14m and it ships today » / « Order now, ships Monday »
 *  - [data-sa-arrival] : « Tue, Sep 16 – Thu, Sep 18 »
 *  - [data-sa-shipdate] : « Fri, Sep 11 » (jour d'expédition)
 * Le HTML est déjà rendu par Liquid (snippets/sa-shipping-calc.liquid) : ce script ne fait que le rafraîchir.
 * Config : <script type="application/json" data-sa-ship-config>{...}</script>
 */
(() => {
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const DAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const DAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function readConfig() {
    const el = document.querySelector('[data-sa-ship-config]');
    const base = { cutoff: 12, tz: 'America/New_York', minDays: 4, maxDays: 6, shipDays: [1, 2, 3, 4, 5] };
    if (!el) return base;
    try {
      const cfg = JSON.parse(el.textContent);
      cfg.shipDays = (cfg.shipDays || base.shipDays).map(Number);
      return { ...base, ...cfg };
    } catch (e) {
      return base;
    }
  }

  // Heure « murale » de New York → objet { y, m, d, h, mi, wd } (wd : 0 = dimanche … 6 = samedi)
  function nowInZone(tz) {
    let fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hour12: false, weekday: 'short',
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',
      });
    } catch (e) {
      fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', hour12: false, weekday: 'short',
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',
      });
    }
    const p = Object.fromEntries(fmt.formatToParts(new Date()).map((x) => [x.type, x.value]));
    return {
      y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute,
      wd: DAYS_SHORT.indexOf(p.weekday),
    };
  }

  // Jours « muraux » manipulés en UTC pour éviter tout décalage local.
  const wall = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
  const addDays = (date, n) => new Date(date.getTime() + n * 86400000);
  const isoDay = (date) => ((date.getUTCDay() + 6) % 7) + 1; // 1 = lundi … 7 = dimanche
  const label = (date) => `${DAYS_SHORT[date.getUTCDay()]}, ${MONTHS[date.getUTCMonth()]} ${date.getUTCDate()}`;

  function compute(cfg) {
    const now = nowInZone(cfg.tz);
    const today = wall(now.y, now.m, now.d);
    const shipsToday = cfg.shipDays.includes(isoDay(today)) && now.h < cfg.cutoff;

    let shipDate = today;
    if (!shipsToday) {
      for (let i = 1; i <= 7; i++) {
        const candidate = addDays(today, i);
        if (cfg.shipDays.includes(isoDay(candidate))) { shipDate = candidate; break; }
      }
    }

    const addBusiness = (from, n) => {
      let date = from, count = 0;
      while (count < n) {
        date = addDays(date, 1);
        if (isoDay(date) < 6) count++;
      }
      return date;
    };

    const arrival = `${label(addBusiness(shipDate, cfg.minDays))} – ${label(addBusiness(shipDate, cfg.maxDays))}`;

    let cutoffText;
    if (shipsToday) {
      const remaining = cfg.cutoff * 60 - (now.h * 60 + now.mi);
      const h = Math.floor(remaining / 60);
      const mi = remaining % 60;
      cutoffText = `Order within ${h}h ${mi}m and it ships today`;
    } else {
      const tomorrow = addDays(today, 1);
      const isTomorrow = shipDate.getTime() === tomorrow.getTime();
      cutoffText = isTomorrow ? 'Order now, ships tomorrow' : `Order now, ships ${DAYS_LONG[shipDate.getUTCDay()]}`;
    }

    return { arrival, cutoffText, shipLabel: label(shipDate) };
  }

  let timer = null;
  function refresh() {
    const cfg = readConfig();
    const { arrival, cutoffText, shipLabel } = compute(cfg);
    document.querySelectorAll('[data-sa-arrival]').forEach((el) => { if (el.textContent !== arrival) el.textContent = arrival; });
    document.querySelectorAll('[data-sa-cutoff]').forEach((el) => { if (el.textContent !== cutoffText) el.textContent = cutoffText; });
    document.querySelectorAll('[data-sa-shipdate]').forEach((el) => { if (el.textContent !== shipLabel) el.textContent = shipLabel; });
  }

  function start() {
    refresh();
    if (timer) clearInterval(timer);
    timer = setInterval(refresh, 60000);
  }

  // Le tiroir panier ré-injecte son HTML à chaque mise à jour : on ré-applique après toute insertion.
  let pending = null;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = setTimeout(() => { pending = null; refresh(); }, 80);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.SAShipping = { refresh };
})();
